const contactForms = document.querySelectorAll(".tt-contact-section form.contact-form");

if (contactForms.length && window.jQuery) {
    const matchingForm = (settings) => {
        if (
            settings.type?.toUpperCase() !== "POST" ||
            !(settings.data instanceof FormData)
        ) {
            return null;
        }

        return [...contactForms].find((form) => {
            const fields = form.querySelector('input[name="display_fields"]');
            return (
                new URL(settings.url, window.location.href).href === form.action &&
                fields &&
                settings.data.get("display_fields") === fields.value
            );
        });
    };

    jQuery(document).on("ajaxSend", (_event, _request, settings) => {
        const form = matchingForm(settings);
        const button = form?.querySelector('button[type="submit"]');
        if (!button) return;

        button.dataset.idleLabel = button.textContent;
        button.textContent = "Đang gửi...";
        button.classList.add("is-submitting");
        button.setAttribute("aria-busy", "true");
        button.disabled = true;
    });

    jQuery(document).on("ajaxComplete", (_event, _request, settings) => {
        const form = matchingForm(settings);
        const button = form?.querySelector('button[type="submit"]');
        if (!button) return;

        button.textContent = button.dataset.idleLabel || "Gửi";
        delete button.dataset.idleLabel;
        button.classList.remove("is-submitting");
        button.removeAttribute("aria-busy");
        button.disabled = false;
    });
}
